module.exports = __webpack_public_path__ + "fontawesome-webfont.d379f0ff610e7d801e93.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/global-css/fonts/font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = ./src/app/global-css/fonts/font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0
// module chunks = main